/* Zewye90 theme.js — no dependencies
   The scrolling wall lives in marquee.js. */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- scroll reveals ---------------- */
  (function () {
    if (REDUCED || !('IntersectionObserver' in window)) return;
    var GROUPS = ['.sec-head', '.sec-intro', '.piece', '.kit', '.vdrawer',
                  '.note', '.fmt', '.foot-brand', '.foot-col', '.coll-head'];
    var nodes = document.querySelectorAll(GROUPS.join(','));
    if (!nodes.length) return;

    var counters = new Map();
    nodes.forEach(function (el) {
      if (el.closest('.mq-wrap')) return;
      var key = el.parentElement || document.body;
      var n = counters.get(key) || 0;
      counters.set(key, n + 1);
      el.style.setProperty('--d', Math.min(n, 7) * 55 + 'ms');
      el.classList.add('rv');
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });

    document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
    requestAnimationFrame(function () {
      document.querySelectorAll('.rv').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { el.classList.add('in'); io.unobserve(el); }
      });
    });
  })();

  /* ---------------- header shadow on scroll ---------------- */
  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var ticking = false;
    function update() { header.classList.toggle('scrolled', window.scrollY > 8); ticking = false; }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    update();
  })();

  /* ---------------- mobile menu ---------------- */
  var burger = document.getElementById('burger');
  if (burger) {
    burger.addEventListener('click', function () {
      var open = document.body.classList.toggle('menu-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.querySelectorAll('.drawer-nav a').forEach(function (a) {
      a.addEventListener('click', function () {
        document.body.classList.remove('menu-open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('menu-open')) {
        document.body.classList.remove('menu-open');
        burger.setAttribute('aria-expanded', 'false');
        burger.focus();
      }
    });
  }

  /* ---------------- search panel ---------------- */
  (function () {
    var header = document.querySelector('.site-header');
    var panel = document.querySelector('[data-search-panel]');
    if (!header || !panel) return;

    var input = panel.querySelector('[data-search-input]');
    var results = panel.querySelector('[data-search-results]');
    var form = panel.querySelector('[data-search-form]');
    var openers = document.querySelectorAll('[data-search-open]');
    var shopName = (panel.dataset.shopName || '').toLowerCase();
    var timer = null, lastQuery = '';

    function isOpen() { return header.getAttribute('data-search-active') === 'true'; }
    function open() {
      panel.hidden = false;
      requestAnimationFrame(function () {
        header.setAttribute('data-search-active', 'true');
        openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
        input.focus();
      });
      if (document.body.classList.contains('menu-open')) {
        document.body.classList.remove('menu-open');
        if (burger) burger.setAttribute('aria-expanded', 'false');
      }
    }
    function close() {
      header.setAttribute('data-search-active', 'false');
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
      window.setTimeout(function () {
        if (!isOpen()) panel.hidden = true;
      }, 320);
    }

    openers.forEach(function (o) {
      o.addEventListener('click', function (e) { e.preventDefault(); isOpen() ? close() : open(); });
    });
    panel.querySelectorAll('[data-search-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) { close(); if (openers[0]) openers[0].focus(); }
    });
    document.addEventListener('click', function (e) {
      if (isOpen() && !header.contains(e.target)) close();
    });
    form.addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });

    function row(url, title, sub, img) {
      return '<a class="sp-item" href="' + esc(url) + '">' +
             (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span></span>') +
             '<span class="stx"><span class="st">' + esc(title) + '</span>' +
             (sub ? '<span class="sm">' + esc(sub) + '</span>' : '') + '</span></a>';
    }
    function render(data, q) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [], collections = r.collections || [];
      if (!products.length && !collections.length) {
        results.innerHTML = '<p class="sp-hint">No matches yet.</p>';
        return;
      }
      var html = '<div class="sp-list">';
      collections.slice(0, 3).forEach(function (c) { html += row(c.url, c.title, 'Collection', ''); });
      products.slice(0, 6).forEach(function (p) {
        var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
        var sub = (p.vendor && p.vendor.toLowerCase() !== shopName) ? p.vendor : '';
        html += row(p.url, p.title, sub, img);
      });
      html += '</div><a class="sp-all" href="' + ROOT + 'search?q=' + encodeURIComponent(q) + '">See all results</a>';
      results.innerHTML = html;
    }
    function search(q) {
      fetch(ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product,collection&resources[limit]=6')
        .then(function (res) { return res.json(); })
        .then(function (data) { if (input.value.trim() === q) render(data, q); })
        .catch(function () { results.innerHTML = ''; });
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      window.clearTimeout(timer);
      if (q.length < 2) { results.innerHTML = ''; lastQuery = ''; return; }
      if (q === lastQuery) return;
      lastQuery = q;
      timer = window.setTimeout(function () { search(q); }, 220);
    });
  })();

  /* ---------------- slideshow ---------------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var track = root.querySelector('[data-track]');
    var slides = root.querySelectorAll('.slide');
    var dotsEl = root.querySelector('[data-dots]');
    if (!track || !slides.length) return;

    var i = 0, timer = null;
    var auto = parseInt(root.dataset.autoplay, 10) || 0;
    var rtl = document.documentElement.dir === 'rtl';

    if (slides.length > 1 && dotsEl) {
      slides.forEach(function (_, n) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (n + 1));
        b.addEventListener('click', function () { go(n); restart(); });
        dotsEl.appendChild(b);
      });
    }
    var dots = dotsEl ? dotsEl.querySelectorAll('button') : [];

    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (rtl ? i * 100 : -i * 100) + '%)';
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function next() { go(i + 1); }
    function prev() { go(i - 1); }
    function start() { if (auto && !REDUCED && !timer && slides.length > 1) timer = setInterval(next, auto); }
    function stop() { clearInterval(timer); timer = null; }
    function restart() { stop(); start(); }

    var nx = root.querySelector('[data-next]'), pv = root.querySelector('[data-prev]');
    if (nx) nx.addEventListener('click', function () { next(); restart(); });
    if (pv) pv.addEventListener('click', function () { prev(); restart(); });

    var x0 = null, y0 = null, locked = false;
    var view = root.querySelector('.viewport');
    view.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; locked = false; stop();
    }, { passive: true });
    view.addEventListener('touchmove', function (e) {
      if (x0 === null) return;
      var dx = e.touches[0].clientX - x0, dy = e.touches[0].clientY - y0;
      if (!locked && Math.abs(dx) > Math.abs(dy) + 6) locked = true;
    }, { passive: true });
    view.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (locked && Math.abs(dx) > 45) { (dx < 0) !== rtl ? next() : prev(); }
      x0 = null; start();
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    go(0); start();
  });

  /* ---------------- club index preview (desktop) ---------------- */
  var idx = document.querySelector('[data-club-index]');
  if (idx) {
    var pvImg = document.querySelector('[data-pv-img]');
    var pvCap = document.querySelector('[data-pv-cap]');
    var pvSub = document.querySelector('[data-pv-sub]');
    idx.addEventListener('mouseover', function (e) {
      var a = e.target.closest('a[data-img]');
      if (!a || !pvImg) return;
      if (a.dataset.img) pvImg.src = a.dataset.img;
      if (pvCap) pvCap.textContent = a.dataset.cap || '';
      if (pvSub) pvSub.textContent = a.dataset.sub || '';
    });
  }

  /* ---------------- product gallery ---------------- */
  var gal = document.querySelector('[data-gallery]');
  if (gal) {
    var main = gal.querySelector('[data-gallery-main]');
    gal.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.dataset.full;
        main.alt = btn.dataset.alt || '';
        gal.querySelectorAll('[data-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------------- variant picker ----------------
     After choosing a new variant, the picker announces it three ways so
     product-option apps (Easify and similar) can react — e.g. showing
     frame colour only when Framed is selected:
       1. a native change event on the hidden input[name=id]
       2. a variant:change CustomEvent on document
       3. ?variant= in the URL
     Without these, the hidden input changes silently and apps never know. */
  var form = document.querySelector('[data-variant-form]');
  if (form) {
    var data = document.getElementById('variant-data');
    if (data) {
      var variants = JSON.parse(data.textContent);
      var idInput = form.querySelector('[data-variant-id]');
      var priceEl = document.querySelector('[data-price]');
      var btn = form.querySelector('[data-add]');
      var firstRun = true;

      var selected = function () {
        return Array.from(form.querySelectorAll('input[type=radio]:checked')).map(function (r) { return r.value; });
      };
      var update = function () {
        var opts = selected();
        var match = variants.find(function (v) {
          return v.options.every(function (o, n) { return o === opts[n]; });
        });
        if (!match) {
          btn.disabled = true;
          btn.textContent = btn.dataset.unavailable;
          return;
        }

        var changed = String(idInput.value) !== String(match.id);
        idInput.value = match.id;
        if (priceEl) priceEl.innerHTML = match.price_html;
        btn.disabled = !match.available;
        btn.textContent = match.available ? btn.dataset.addLabel : btn.dataset.soldout;

        if (window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', u.toString());
        }

        if (changed || firstRun) {
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
          idInput.dispatchEvent(new Event('input', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('variant:change', {
            detail: { variant: match, options: opts }
          }));
        }
        firstRun = false;
      };

      form.querySelectorAll('input[type=radio]').forEach(function (r) {
        r.addEventListener('change', update);
      });
      update();
    }
  }

  /* ---------------- cart drawer ---------------- */
  var CartDrawer = (function () {
    var root = document.querySelector('[data-cart-drawer]');
    if (!root) return null;
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-open');
      var x = root.querySelector('.cd-x');
      if (x && x.focus) x.focus();
    }
    function close() {
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function refresh() {
      return fetch(ROOT + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-drawer'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer]');
          if (!fresh) return;
          var wasOpen = root.getAttribute('aria-hidden') === 'false';
          root.innerHTML = fresh.innerHTML;
          root.setAttribute('aria-hidden', wasOpen ? 'false' : 'true');
          bind();
          return fetch(ROOT + 'cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            });
        });
    }
    function change(line, qty) {
      return fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(refresh);
    }
    function bind() {
      root.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
      root.querySelectorAll('[data-cart-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          change(parseInt(b.dataset.line, 10), parseInt(b.dataset.qty, 10));
        });
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.getAttribute('aria-hidden') === 'false') close();
    });
    bind();
    return { open: open, close: close, refresh: refresh };
  })();

  document.querySelectorAll('[data-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!CartDrawer) return;
      e.preventDefault();
      CartDrawer.open();
    });
  });

  /* ---------------- ajax add to cart ---------------- */
  var addForm = document.querySelector('[data-ajax-cart]');
  if (addForm && CartDrawer) {
    addForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = addForm.querySelector('[data-add]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.classList.add('loading'); btn.textContent = '…'; }
      fetch(ROOT + 'cart/add.js', { method: 'POST', body: new FormData(addForm) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return CartDrawer.refresh(); })
        .then(function () { CartDrawer.open(); })
        .catch(function () { addForm.submit(); })
        .finally(function () {
          if (btn) { btn.classList.remove('loading'); btn.textContent = original; }
        });
    });
  }

  /* ---------------- collection sort ---------------- */
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  }
})();
